import { useSyncExternalStore } from "react";

import { MINUTE_MS } from "~/utils/constants";

let tick = 0;
let intervalId: ReturnType<typeof setInterval> | null = null;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  if (intervalId === null) {
    intervalId = setInterval(() => {
      tick += 1;
      for (const l of listeners) l();
    }, MINUTE_MS);
  }
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0 && intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };
}

const noopUnsubscribe = () => undefined;
const noopSubscribe = () => noopUnsubscribe;
const getZero = () => 0;

function getSnapshot() {
  return tick;
}

export function useMinuteTick(enabled = true) {
  return useSyncExternalStore(
    enabled ? subscribe : noopSubscribe,
    enabled ? getSnapshot : getZero,
    enabled ? getSnapshot : getZero
  );
}
